import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './components/ui/CopyableId.css';
import './components/ui/GlowCard.css';
import './components/ui/AnimatedNumber.css';
import './components/ui/PageLayout.css';
import './components/ui/PageHeader.css';
import './components/ui/SearchBar.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

